import { createContext, useState } from "react";

export const AuthContext = createContext()

export const AuthProvider = ({ children }) => {
  const [isAuth, setIsAuth] = useState(localStorage.getItem('crmprodtkn'))
  const [globalUser, setGlobalUser] = useState(localStorage.getItem('crmprodusr'))
  const [globalToken, setGlobalToken] = useState(localStorage.getItem('crmprodtkn'))
  const [titlePage, setTitlePage] = useState(false)

  const value = {
    isAuth,
    activateAuth: () => {
      setIsAuth(true)
      const token = localStorage.getItem('crmprodtkn')
      if (token !== null) {
        setIsAuth(true)
        setGlobalToken(token)
      }
    },
    logOut: () => {
      setIsAuth(false)
      setGlobalUser(false)
      setGlobalToken(false)
      localStorage.clear()
    },
    globalUser,
    loadUser: (data) => {
      setGlobalUser(data)
      localStorage.setItem('crmprodusr', data);
    },
    globalToken,
    loadToken: (data) => {
      setGlobalToken(data)
      localStorage.setItem('crmprodtkn', data)
    },
    titlePage, 
    setTitlePage
  }

  return <AuthContext.Provider value={ value }>
          { children }
        </AuthContext.Provider>
}